import { connect } from 'react-redux'
import { getStoreSelected, getSubscription, getOrder } from 'x/redux/selectors'
import { getState, getDispatch } from 'x/modules/order/BaseOrderViewConnect'
import * as bpActions from 'x/modules/shipment/ShipmentState'
import { bindActionCreators } from 'redux'
import * as SearchOrderListStateActions from 'x/modules/orderlist/SearchOrderListState'
import * as OrderStateActions from 'x/modules/order/OrderState'
import SearchOrderView from './SearchOrderView'

export default connect(
  (state) => ({
    selectedStore: getStoreSelected(state),
    subscription: getSubscription(state),
    order: getOrder(state),
    ...getState(state),
  }),
  (dispatch) => ({
    ...getDispatch(dispatch),
    fetchOrderFromBarcode: bindActionCreators(bpActions.fetchOrderFromBarcode, dispatch),
    // navigate: bindActionCreators(NavigationActions.navigate, dispatch),
    fetchOrdersForSearch: bindActionCreators(SearchOrderListStateActions.fetchOrders, dispatch),
    fetchOrderDetail: bindActionCreators(OrderStateActions.fetchOrderDetail, dispatch),
  })
)(SearchOrderView)
